import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Moment } from "moment";


interface IInventoryContext {
    search: string
    inventory: IInventory
    isLoading: boolean

    updateSearch: (newSearch: string) => void
    getInventoriesBySku: () => void
}

export let inventoryContext = React.createContext<IInventoryContext>({} as IInventoryContext);

let { Provider } = inventoryContext;

interface IInventory {
    sku: string
    inventories: IWarehouse[]
}

interface IWarehouse {
    warehouse: string  
    quantity: number
    lastUpdatedOn: Moment
}


export let InventoryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let location = useLocation();
    let navigate = useNavigate();

    let [isLoading, setLoading] = useState(true);

    let [inventory, setInventory] = useState<IInventory>({} as IInventory);

    let [search, setSearch] = useState<string>('');


    if (!location.state)
        return <Navigate to={location.pathname} state={{ search: search }} replace={true} />

    let updateSearch = (newSearch: string) => {
        setSearch(newSearch);
    }

    let getInventoriesBySku = async () => {
        try {
            if (search !== '') {

                let response = await axios.get('/api/Inventory/GetInventoriesBySku', { params: { sku: search } });

                setInventory(response.data.item);
            }

        } catch (error) { }
        finally {
        }
    }

    return (
        <Provider value={{
            search,
            inventory,
            isLoading,

            updateSearch,
            getInventoriesBySku
        }}>
            {children}
        </Provider>
    );
};